







import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin, ModalPresentableMixin } from "../mixins";
import DateTimeSelectDialog from "../dialogs/DateTimeSelectDialog.vue";
import { DateFormatter } from "../../../domain/system/DateFormatter";

@Component({
  components: {
    DateTimeSelectDialog,
  }
})
export default class DateTimePicker extends Mixins(ModelEditableMixin, ModalPresentableMixin) {
  @Prop({ default: false })
  isAlert: boolean;

  @Prop({ default: true })
  isClearable: boolean;

  $refs!: {
    dateTimeSelectDialog: DateTimeSelectDialog;
  };

  get displayText(): string {
    return this.editingSource
      ? DateFormatter.format(this.editingSource as Date, "YYYY/MM/DD HH:mm")
      : null;
  }

  set displayText(value: string) {
  }

  get calenderStyles(): any {
    return {
      color: this.isAlert ? this.alertColor : null,
      backgroundColor: this.isAlert ? this.alertBackgroundColor : null,
    };
  }

  get alertColor(): string {
    return this.$configuration.style.alertIndication.color;
  }

  get alertBackgroundColor(): string {
    return this.$configuration.style.alertIndication.backgroundColor;
  }

  async showCalender(): Promise<void> {
    if (this.$refs.dateTimeSelectDialog) {
      const result = await this.$refs.dateTimeSelectDialog.show(this.editingSource);
      if (result === undefined) { return; }
      this.editingSource = result;
    }
  }
}
